<template>
  <el-group-title title="物资合同补充协议" class="contractMaterialsProtocol">
    <template slot="groupTitle">
      <el-form
        :model="formcontractMaterialsProtocol"
        label-width="100px"
        class="ccui-form ccui-form-detail"
        style="overflow: visible"
      >
        <el-table
          :data="dataInfo"
          style="margin-bottom: 20px; width: 100%"
          class="ccui-form-child-table"
          border
          max-height="99999"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            label="序号"
            type="index"
            align="center"
            fixed
          />
          <el-table-column
            :show-overflow-tooltip="true"
            prop="initContractName"
            label="原合同名称"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="initContractCode"
            label="原合同编码"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolCode"
            label="补充协议编号"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolName"
            label="补充协议名称"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="protocolTaxRate"
            label="补充协议税率"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowSigner"
            label="变更合同签订人"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowPriceIncludeTax"
            label="变更后含税金额（元）"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowTax"
            label="变更后税额"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="nowPriceExcludeTax"
            label="变更后不含税金额"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="compileDate"
            label="补充协议编制日期"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="takeEffectDate"
            label="协议价格生效日期"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="contractPerson"
            label="对方联系人"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="priceFillingMethod"
            label="价格填写方式"
            align="left"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="mainTermsOfContract"
            label="合同主要条款"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="remark"
            label="备注"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="contractState"
            label="合同状态"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="checkState"
            label="审批状态"
          >
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="isEnabled"
            label="是否最新生效"
            align="left"
          >
          </el-table-column>
          <!-- <el-table-column
            :show-overflow-tooltip="true"
            prop="scaleNum"
            label="操作"
            align="center"
            width="100%"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="delTable(scope.$index, scope.row)"
              >
                删除
              </el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-form>
    </template>
  </el-group-title>
</template>

<script>
export default {
  name: "contractMaterialsProtocol",
  props: {
    dataInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableData: [
        {
          id: "",
          contractMaterialsId: "",
          initContractName: "",
          initContractCode: "",
          partyAId: "",
          partyBId: "",
          protocolCode: "",
          protocolName: "",
          protocolTaxRate: "",
          nowSigner: "",
          nowPriceIncludeTax: "",
          nowTax: "",
          nowPriceExcludeTax: "",
          compileDate: "",
          takeEffectDate: "",
          contractPerson: "",
          priceFillingMethod: "",
          mainTermsOfContract: "",
          remark: "",
          contractState: "",
          checkState: "",
          isEnabled: ""
        }
      ],
      formcontractMaterialsProtocol: {}
    };
  },
  watch: {
    dataInfo() {
      let contractStateObj = {
        "01": "未提交",
        "02": "审核中",
        "03": "审核通过",
        "04": "审核退回",
        "05": "审批不通过",
        "06": "审批追回"
      };

      let checkStateObj = {
        "01": "待审批",
        "02": "审核中",
        "03": "审核通过",
        "04": "审批不通过"
      };
      this.tableData = this.dataInfo;
      if (this.tableData) {
        this.tableData.forEach(item => {
          item.compileDate = item.compileDate
            ? item.compileDate.substr(0, 10)
            : "";
          item.takeEffectDate = item.takeEffectDate
            ? item.takeEffectDate.substr(0, 10)
            : "";
          item.contractState = contractStateObj[item.contractState];
          item.checkState = checkStateObj[item.checkState];
        });
      }
    }
  }
};
</script>
